import React, { useState, useEffect } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, setDoc, doc, collection, query, where, writeBatch, onSnapshot, addDoc } from "firebase/firestore";
import { db, } from "../../../firebase";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import { TextField, Button } from '@mui/material';

const New = () => {

  const [announcement, setAnnouncement] = useState("")
  const [errorAnnouncement, setErrorAnnouncement] = useState(false)
  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const navigate = useNavigate();


  const Spinner = () => {
    return(
      <span className='spinner-container'>
          <span className='loading-spinner'></span>
      </span>
    )
  }



  //  useEffect(() => {
  
  
  //     const collectionRef = collection(db, "subscribers")
  
  //     const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Platinum"))
  
  //     const unsub = onSnapshot(querySubscribers, (snapShot) => {
  //       let list = [];
  //       snapShot.docs.forEach((doc) => {
  //         list.push(doc.data().userId)
  //       })
  //       setPlatinumList(list)
  //     }, 
  //       (error) => {
  //         console.log(error)
  //       }
  //     );
  
  //     return () => {
  //       unsub();
  //     }
  
  // //END LISTEN REAL TIME    
  
  //   },[])


  //   useEffect(() => {
  
  
  //     const collectionRef = collection(db, "subscribers")
  
  //     const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Premium"))
  
  //     const unsub = onSnapshot(querySubscribers, (snapShot) => {
  //       let list = [];
  //       snapShot.docs.forEach((doc) => {
  //         list.push(doc.data().userId)
  //       })
  //       setPremiumList(list)
  //     }, 
  //       (error) => {
  //         console.log(error)
  //       }
  //     );
  
  //     return () => {
  //       unsub();
  //     }
  
  // //END LISTEN REAL TIME    
  
  //   },[])


  //   useEffect(() => {
  
  
  //     const collectionRef = collection(db, "subscribers")
  
  //     const querySubscribers = query(collectionRef, where("subscriberPlan", "==", "Standard"))
  
  //     const unsub = onSnapshot(querySubscribers, (snapShot) => {
  //       let list = [];
  //       snapShot.docs.forEach((doc) => {
  //         list.push( doc.data().userId )
  //       })
  //       setStandardList(list)
  //     }, 
  //       (error) => {
  //         console.log(error)
  //       }
  //     );
  
  //     return () => {
  //       unsub();
  //     }
  
  // //END LISTEN REAL TIME    
  
  //   },[])


  // const handleChange = (event) => {
  //   setPlan(event.target.value);
  // };

  //  const handleChangeIcon = (event) => {
  //   setIcon(event.target.value);
  // };

  // const handleChangeIconColor = (event) => {
  //   setIconcolor(event.target.value);
  // };


  const handleAdd = async(e) => {

          e.preventDefault()


          if(announcement === ""){

            return setErrorAnnouncement(true)

          }
          
          setIsloading(true)
      
          try{
                
                await addDoc(collection(db, "announcement"), {
                
                Description : announcement,

                createdAt : today,
              
            });
    
            setIsloading(false)
    
            navigate("/announcement")
            
          }catch (err) {
    
            console.log(err);
    
          } 

  }


  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Announcement</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/announcement"
            >
              Announcement List
            </Link>
            <Typography color="green">New Announcement</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
          <div className='right'>
            <div className='form' onSubmit={handleAdd}>

          
                <TextField
                  id="announcement" 
                  value={announcement}
                  multiline
                  minRows={3}
                  maxRows={10}
                  placeholder="Enter Announcement (Not more than 12 Words)"
                  style={{width:'50%'}}
                  onChange={(e) => setAnnouncement(e.target.value)}
                />

                {
                  errorAnnouncement &&

                   <p style={{color:'red', fontSize:12}}>This field is required</p>

                }
              


              <Button onClick={handleAdd} style={{width:'50%', backgroundColor:'rgb(15, 31, 175)'}}>{isloading ? '...saving Announcement': 'Send Announcement'}</Button>

             {/* <button disabled={perc !== null && perc < 100} type='submit' >Submit</button> */}

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default New
